import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#6496dc",
      d: "M16 29c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m13.202 19.635 8.419-8.42a2.242 2.242 0 1 1 3.17 3.171l-5.24 5.249a4.493 4.493 0 0 1-6.349 0Zm5.585-7.269-8.419 8.42A2.24 2.24 0 0 1 6.543 19.2c0-.594.235-1.164.655-1.585l5.24-5.249a4.493 4.493 0 0 1 6.35 0Z"
    }, null, -1)
  ])))
}
export default { render: render }